import type { ReactNode } from 'react'
import { InboxOutlined } from '@ant-design/icons'
import { Button, Empty, Flex, Typography, theme } from 'antd'

interface EmptyStateProps {
  /** Ikonka — kontekstni bir qarashda beradi */
  icon?: ReactNode
  title: string
  /** Nima uchun bo'sh va nima qilish kerakligini tushuntiradi */
  description?: string
  /** Harakat tugmasi — bo'sh holat boshi berk ko'cha bo'lmasin (UI/UX talabi) */
  actionLabel?: string
  onAction?: () => void
}

/**
 * Bo'sh holat: ikonka + sarlavha + tushuntirish + harakat tugmasi.
 *
 * Yalang'och "ma'lumot yo'q" yozuvi abonentni nima qilishni bilmay
 * qoldiradi — bu yerda doim IKKI narsa aytiladi: nega bo'sh va (bo'lsa)
 * nima bosish kerak. Masalan bo'sh "Paketlar" ro'yxati emas, "hozircha
 * paket yo'q, keyinroq qayting" kabi aniq holat.
 */
export function EmptyState({ icon, title, description, actionLabel, onAction }: EmptyStateProps) {
  const { token } = theme.useToken()

  return (
    <Empty
      image={
        <div style={{ fontSize: 44, color: token.colorTextQuaternary, lineHeight: 1 }}>
          {icon ?? <InboxOutlined />}
        </div>
      }
      styles={{ image: { height: 'auto', marginBottom: 12 } }}
      description={
        <Flex vertical align="center" gap={6} style={{ maxWidth: 420, margin: '0 auto' }}>
          <Typography.Text strong style={{ fontSize: 15 }}>
            {title}
          </Typography.Text>
          {description ? (
            <Typography.Text type="secondary" style={{ fontSize: 13 }}>
              {description}
            </Typography.Text>
          ) : null}
        </Flex>
      }
    >
      {actionLabel && onAction ? (
        <Button type="primary" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </Empty>
  )
}
